import { z } from 'zod';
import { IContactFullObject } from './IContact';
import { documentSchema, IDocument } from './IDocument';
import { IMortgagePerson } from './IPerson';
import { IPersonHasDocument } from './IPersonHasDocument';
import { realEstateSchema } from './IRealEstate';
import { ICompany } from './ICompany';
import { ILegalClient } from './ILegalClient';

export const mortgageDocumentSchema = documentSchema.extend({
  DocumentPurpose: z.string().optional(),
});

export const mortgageSchema = z.object({
  idMortgage: z.number(),
  idPerson: z.number(),
  idLegalTransaction: z.number(),
  RealEstate: realEstateSchema,
  NewMortgage: z.boolean(),
  MortgageInterest: z.number().nullable(),
  AmountMortgage: z.number().nullable(),
  Beneficiary: z.string(),
  BeneficiaryType: z.string().optional().nullable(),

  PropertyForBuying: z.boolean().nullable(),
  PropertyOwned: z.boolean().nullable(),
  RealEstateLandRegistryData: z.string(),
  DocumentIndexNumber: z.string().optional(),
  OperationNumber: z.string().optional(),
  Paragraph: z.boolean(),
  Transcripts: z.array(z.string()).optional(),
  id: z.number(),
  Remarks: z.string().optional(),
  AdditionalServices: z.string(),
  DocumentArray: z.array(mortgageDocumentSchema),
  ToBeDeleted: z.boolean(),
});

export type MortgageDocument = z.infer<typeof mortgageDocumentSchema>;
export type IMortgageRaw = z.infer<typeof mortgageSchema>;

export interface IMortgage extends IMortgageRaw {
  BeneficiaryDetails: IMortgagePerson | ICompany;
}

export interface IMortgageFullObject extends IMortgage {
  PersonArray: IMortgagePerson[];
  PersonHasDocument: IPersonHasDocument[];
  Document?: IDocument;
  ContactObject?: IContactFullObject;
  LegalClientArray: ILegalClient[];
  syncWithArnoTop?: boolean;
}
